























































































import { Vue, Component, Emit, Prop } from 'vue-property-decorator'
import {
  SpringExam,
  SpringExamTime,
  SpringExamSkill,
  SpringExamProject
} from '@/models/springexam/SpringExam'
import { randKey } from '@/utils/random'
import { ElForm } from 'element-ui/types/form'
import { put } from '@/api/springexam/springexam'
import { notify, comfirm } from '@/utils/notification'

@Component
export default class ExamEditor extends Vue {
  @Prop({ type: Object, required: true }) form!: SpringExam
  randKey = randKey()
  rules = {
    name: [{ required: true, message: '请输入考试名称', trigger: 'blur' }],
    explain: [{ required: true, message: '请输入考试说明', trigger: 'blur' }]
  }

  handleAddProject() {
    this.form.examProjects.push({
      projectName: '',
      examTimes: [],
      examSkills: []
    })
  }

  handleAddProjectTime(project: SpringExamProject) {
    project.examTimes.push({
      examTime: '',
      planCount: 0,
      selectedCount: 0
    })
  }

  handleAddProjectSkill(project: SpringExamProject) {
    project.examSkills.push({
      skillName: ''
    })
  }

  handleDeleteProject(project: SpringExamProject) {
    const index = this.form.examProjects.indexOf(project)
    if (index !== -1) this.form.examProjects.splice(index, 1)
  }

  handleRemoveTime(project: SpringExamProject, examTime: SpringExamTime) {
    const index = project.examTimes.indexOf(examTime)
    if (index !== -1) project.examTimes.splice(index, 1)
  }

  handleRemoveSkill(project: SpringExamProject, examSkill: SpringExamSkill) {
    const index = project.examSkills.indexOf(examSkill)
    if (index !== -1) project.examSkills.splice(index, 1)
  }

  async validForm(el: ElForm) {
    try {
      await el.validate()
      return true
    } catch (e) {
      return false
    }
  }

  async handleEdit() {
    if (await this.validForm(this.$refs.form as any)) {
      try {
        this.form.examProjects.forEach(project => {
          project.examTimes.forEach(time => {
            time.planCount = Number(time.planCount)
          })
        })
        await put(this.form.id as string, this.form)
        notify('修改考试成功')
        this.$emit('SaveSuccess')
      } catch (e) {
        notify('修改考试失败', e)
      } finally {
        this.form = {
          name: '',
          explain: '',
          examProjects: [],
          examUsers: []
        }
      }
    }
  }

  @Emit('clickReturn')
  onReturn($event: any) {
    this.form = {
      name: '',
      explain: '',
      examProjects: [],
      examUsers: []
    }
    return $event
  }
}
